import useApiFetch from '@/hooks/useApiFetch';
import candidatesServices from '@/services/candidates';
import { FetchApiIds } from '@/types';
import { TotalCandidatesByTechStack } from '@/types/api';
import TalentPoolChartComponent from './TalentPoolChart.component';

const TalentPoolChart = (): JSX.Element => {
  const response = useApiFetch<TotalCandidatesByTechStack[]>(
    FetchApiIds.GET_TOTAL_CANDIDATES_BY_TECH_STACK,
    candidatesServices.getTotalCandidatesByTechStack
  );

  const { data } = response;

  return (
    <TalentPoolChartComponent
      title="Talent Pool"
      tooltipMessage="This chart displays the total number of candidates in our Talent Pool. It includes all candidates that reached or past the Ready to Hire status and were not hired or allocated yet, nor rejected after it."
      data={data ?? []}
    />
  );
};

export default TalentPoolChart;
